<template>
  <div class="gfb-radio-input">
    <input
      :type="type"
      :id="inputId"
      :name="name"
      :value="value"
      :checked="checked"
      @change="$emit('change')"
    />
    <label :for="inputId">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "radio-input",
  props: {
    type: { type: String, default: "radio" },
    inputId: { type: String, required: true },
    name: { type: String, default: null },
    value: { default: null },
    checked: { type: Boolean, default: false },
    label: { type: String, required: true },
  },
  emits: ["change"],
}
</script>
